"use client"

export default function CourseCurriculum() {
  const leftColumnItems = [
    "Agentic System Design Mindset",
    "Easy, step-by-step explanation",
    "Weekly Live Code Review Clinics",
    "Capstone Project",
  ]

  const rightColumnItems = [
    {
      title: "Scalable agent systems",
      description: "Design systems that coordinate tasks, share memory, and operate in real-time environments.",
    },
    {
      title: "Scalable Multi-Agent RAG Architecture",
      description:
        "Build Multi-Agent RAG Systems with persistent memory, tool orchestration, and modular planning flows.",
    },
    {
      title: "Enterprise-ready agentic system",
      description: "Data-driven experimentation reduces time-to-market from quarters to weeks",
    },
  ]

  return (
    <section className="relative py-12 sm:py-16 lg:py-20 overflow-hidden bg-gray-950">
      {/* Background elements */}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_80%_20%,rgba(0,158,61,0.08),transparent_60%)]"></div>
      <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-green-500/30 to-transparent"></div>

      <div className="relative z-10 container px-4 sm:px-6 mx-auto">
        <div className="mb-12">
          <div className="w-24 h-1 mb-6" style={{ backgroundColor: "#009E3D" }}></div>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-montserrat font-bold mb-6" style={{ color: "#FFFFFF" }}>
            Enterprise Agentic AI Focus
          </h2>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          {/* Left Column */}
          <div>
            <h3
              className="text-2xl sm:text-3xl lg:text-4xl font-montserrat font-bold mb-8 leading-tight"
              style={{ color: "#FFFFFF" }}
            >
              Not just <span style={{ color: "#009E3D" }}>Chatbots</span> but
              <br />
              Production grade
              <br />
              <span style={{ color: "#009E3D" }}>Autonomous Agents</span>
            </h3>

            <p className="text-lg font-vietnam font-semibold mb-8" style={{ color: "#FFFFFF" }}>
              Get the best of Agentic AI
            </p>

            <div className="border border-gray-600/50 rounded-lg p-6 bg-gray-900/40 backdrop-blur-sm">
              <div className="space-y-4">
                {leftColumnItems.map((item, index) => (
                  <div key={index} className="flex items-start gap-3">
                    <div
                      className="w-2 h-2 rounded-full mt-2 flex-shrink-0"
                      style={{ backgroundColor: "#009E3D" }}
                    ></div>
                    <span className="text-base font-vietnam leading-relaxed" style={{ color: "#FFFFFF", opacity: 0.9 }}>
                      {item}
                    </span>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Right Column */}
          <div>
            <h3 className="text-xl sm:text-2xl font-vietnam font-bold mb-8" style={{ color: "#FFFFFF" }}>
              Hands on practice on:
            </h3>

            <div className="border-2 border-green-500/50 rounded-lg p-6 bg-gray-900/40 backdrop-blur-sm">
              <div className="space-y-6">
                {rightColumnItems.map((item, index) => (
                  <div key={index}>
                    <h4 className="font-vietnam font-semibold text-base mb-2" style={{ color: "#009E3D" }}>
                      {item.title}
                    </h4>
                    <p className="text-sm font-vietnam leading-relaxed" style={{ color: "#FFFFFF", opacity: 0.8 }}>
                      {item.description}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
